import { townColorHex as hex } from './townPropTemplates';
import type { TownPropPalette } from './townPropTemplates';

/** Short rope lashings read as joinery, never as a climbable rope. */
function ropeTie(x: number, y: number, p: TownPropPalette): string {
  return `<path d="M${x} ${y}q4 -2 8 0 m-8 3q4 -2 8 0" fill="none" stroke="${hex(p.stone)}" stroke-width="1.2" />`;
}

/** Roofless 100×126 bay. The authored platform above supplies the standable canopy. */
export function buildMarketStallBody(p: TownPropPalette): string {
  const cloth = hex(p.primary), shade = hex(p.shade), wood = hex(p.wood), edge = hex(p.woodEdge);
  const iron = hex(p.iron), sack = hex(p.stone), grain = hex(p.roofEdge);
  return `
    <g data-part="stall-valance">
      <path d="M0 0H100V10Q90 17 80 10Q70 17 60 10Q50 17 40 10Q30 17 20 10Q10 17 0 10Z" fill="${cloth}" />
      <path d="M0 0H100V3H0Z M20 3V10 M40 3V10 M60 3V10 M80 3V10" fill="none" stroke="${shade}" stroke-width="1.5" />
      <path d="M2 10Q10 14 18 10 M22 10Q30 14 38 10 M42 10Q50 14 58 10 M62 10Q70 14 78 10 M82 10Q90 14 98 10"
        fill="none" stroke="${grain}" stroke-width="0.65" opacity="0.6" />
    </g>
    <g data-part="stall-posts">
      <rect x="3" y="13" width="6" height="113" fill="${wood}" />
      <rect x="94" y="13" width="5" height="113" fill="${wood}" />
      <path d="M4 29V100 M95 29V100" stroke="${edge}" stroke-width="0.65" opacity="0.25" />
      <path d="M2 121H10V126H2Z M93 121H100V126H93Z" fill="${iron}" />
      ${ropeTie(2, 17, p)} ${ropeTie(92, 17, p)}
    </g>
    <g data-part="provision-sign">
      <path d="M13 12V17 M33 12V17" stroke="${iron}" stroke-width="0.8" />
      <path d="M11 17H35V27H11Z" fill="${wood}" />
      <path d="M12 18H34V26H12Z" fill="none" stroke="${edge}" stroke-width="0.65" />
      <path d="M16 24Q15 20 19 20H28Q31 20 30 24Z" fill="${grain}" />
      <path d="M20 21L19 23 M24 21L23 23 M28 21L27 23" stroke="${wood}" stroke-width="0.8" />
    </g>
    <g data-part="stall-counter">
      <path d="M14 109Q11 100 18 96L17 93H26L25 96Q33 102 29 109Z" fill="${sack}" />
      <path d="M17 97H27 M20 99L18 106 M23 95V92" fill="none" stroke="${wood}" stroke-width="0.8" />
      <path d="M37 110L35 100H61L59 110Z" fill="${wood}" />
      <path d="M36 101H60 M37 106H59 M40 101L41 109 M47 101V109 M55 101L54 109" stroke="${edge}" stroke-width="0.8" />
      <path d="M39 100Q38 95 43 95Q47 95 46 100 M46 100Q46 94 51 94Q56 94 55 100 M53 100Q54 96 58 97L60 100Z" fill="${grain}" />
      <path d="M7 110H95V114H7Z" fill="${edge}" />
      <path d="M9 114H94V123H9Z" fill="${wood}" />
      <path d="M12 116H90 M20 116V121 M43 116V121 M68 116V121" stroke="${shade}" stroke-width="1" />
      <path d="M11 112H91" stroke="${grain}" stroke-width="0.7" opacity="0.6" />
      ${ropeTie(2, 108, p)} ${ropeTie(92, 108, p)}
    </g>`;
}
